/* eslint-disable indent */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, Fragment } from "react";

import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Skeleton from "react-loading-skeleton";

import { helperFunction } from "../../constant/helper";
import { userActions } from "../../redux/actions";
import Card from "../../component/card/Card";
import UserLeftDetail from "./UserLeftDetail";
import UserCalendar from "./UserCalendar";
import moment from "moment";
import {
  // createdAsFunction,
  renderSheetCreatedAs
} from "../../constant/helper/helper";
import UserEdit from "./UserEdit";
import isEmpty from "../../validation/isEmpty";
import {
  getAllDepartment,
  getAllDesignation,
  getReportingMangers
} from "../../redux/actions/hrActions";
import UserLocationList from "./UserLocationList";
import { types } from "../../redux/type";
import Starter from "../../component/Starter";
import {
  ATTENDANCE_BACKGROUND_COLOR,
  CREATED_AS_STATUS
} from "../../constant/constant";

const initialState = {
  workerId: "",
  workerType: "",
  workerEmail: "",
  workerStatus: "",
  locationName: "",
  locationType: "",
  departmentId: "",
  workerSurname: "",
  designationId: "",
  lastLocationId: "",
  workerFirstName: "",
  allowFencing: false,
  workerPhoneNumber: "",
  workerAadharCardNumber: "",
  registerFaceImages: []
};

const LoginTypes = {
  Employee: "Employee",
  Worker: "Worker"
};

const showOptions = Object.values(LoginTypes).map((type, index) => (
  <option value={type} key={index}>
    {type}
  </option>
));

const UserDetail = () => {
  const loginType = localStorage.loginType;
  const dispatch = useDispatch();
  const { user_id } = useParams();
  const [department, setDepartment] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [allLocations, setAllLocations] = useState([]);
  const [lastLocationId, setLastLocationId] = useState("");
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [reportingIds, setReportingIds] = useState([]);
  const [reportingManagers, setReportingManagers] = useState([]);
  const [userDetailData, setUserDetailData] = useState(null);
  const [newLocationToUser, setNewLocationToUser] = useState("");
  const [editUserDetail, setEditUserDetail] = useState(initialState);

  const {
    allDesignations,
    allDepartments,
    allReportingManagers
  } = useSelector((state) => state.hr);
  const { currentUser } = useSelector((state) => state.auth);
  const { locations } = useSelector((state) => state.location);

  const {
    userError,
    userDetail,
    userLoading,
    userResponse,
    userAddLoading,
    userCalendarData
  } = useSelector((state) => state.user);

  useEffect(() => {
    const newList = [];
    if (!isEmpty(allReportingManagers)) {
      allReportingManagers.map((reporting) => {
        newList.push({
          label:
            reporting.managerName +
            " - " +
            reporting.managerDesignation,
          value: reporting._id
        });
      });

      setReportingManagers(newList);
    }
  }, [allReportingManagers]);

  useEffect(() => {
    setTimeout(() => {
      if (allDesignations.length === 0) {
        dispatch(getAllDesignation(loginType));
      }
      if (allDepartments.length === 0) {
        dispatch(getAllDepartment(loginType));
      }
      const filter = "ALL";
      dispatch(getReportingMangers(filter, loginType));
    }, 1000);
    return () => {
      dispatch(userActions.clearUserErrors());
      dispatch(userActions.clearUserResult());
      dispatch(userActions.setAddLocationLoading(false));
    };
  }, []);

  useEffect(() => {
    if (allDepartments !== null) {
      setDepartment(allDepartments);
    } else {
      setDepartment([]);
    }
  }, [allDepartments]);

  useEffect(() => {
    if (allDesignations !== null) {
      setDesignation(allDesignations);
    } else {
      setDesignation([]);
    }
  }, [allDesignations]);

  useEffect(() => {
    if (!isEmpty(locations)) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  useEffect(() => {
    if (userResponse) {
      helperFunction.toastHelper("success", userResponse);
    }
    if (userError) {
      helperFunction.toastHelper("error", userError);
    }
  }, [userResponse, userError]);

  useEffect(() => {
    const filterBy = "mongoId";
    dispatch(userActions.getUserDetail(user_id, loginType, filterBy));
  }, [user_id]);

  useEffect(() => {
    if (userDetail !== null) {
      setUserDetailData(userDetail);
      setLastLocationId(userDetail.lastLocationId._id);
      // console.log(userDetail);
      if (!isEmpty(userDetail.reportingIds)) {
        const newList = [];
        userDetail.reportingIds.map((reporting) => {
          newList.push({
            label:
              reporting.managerName +
              " - " +
              reporting.managerDesignation,
            value: reporting._id
          });
        });

        setReportingIds(newList);
      }

      setEditUserDetail(userDetail);
    }
  }, [userDetail]);

  const deleteFace = (e, userLocationDetail) => {
    e.preventDefault();
    dispatch(userActions.clearUserErrors());
    dispatch(userActions.clearUserResult());
    dispatch(
      userActions.deleteFace(
        userLocationDetail._id,
        user_id,
        loginType
      )
    );
  };

  const addNewLocationToUser = () => {
    if (newLocationToUser !== "") {
      const addLocationData = {
        locationId: newLocationToUser,
        employeeId: userDetailData._id
      };

      dispatch(userActions.clearUserErrors());
      dispatch(userActions.clearUserResult());
      dispatch(userActions.setAddLocationLoading(true));
      dispatch(
        userActions.addLocationToUserAction(
          addLocationData,
          loginType
        )
      );
    } else {
      const errorData = {
        data: { message: "Please Select Location" },
        status: 400
      };
      dispatch({
        type: types.UserTypes.USER_GET_ERRORS,
        payload: errorData
      });
    }
  };

  useEffect(() => {
    if (
      !isEmpty(userCalendarData) &&
      !isEmpty(userCalendarData.attendances)
    ) {
      const attendanceData = userCalendarData.attendances.map(
        (calendarData) => {
          const parts = calendarData.date.split("/"); // Split the string by "/"
          const day = parts[0];
          const month = parts[1];
          const year = parts[2];

          // Construct the new date string in "year/month/day" format
          const newDateString = `${year}-${month}-${day}`;

          const type =
            CREATED_AS_STATUS[renderSheetCreatedAs(calendarData)];

          return {
            title: !isEmpty(type) ? type : "AB",
            date: newDateString,
            color: "#777777",
            backgroundColor:
              ATTENDANCE_BACKGROUND_COLOR[
                renderSheetCreatedAs(calendarData)
              ]
          };
        }
      );
      setCalendarEvents(attendanceData);
    } else if (typeof userCalendarData === "undefined") {
      setCalendarEvents([]);
    } else {
      setCalendarEvents([]);
    }
  }, [userCalendarData]);

  // handel month change
  const handleMonthChange = (payload) => {
    const dateRange = {
      fromDate: moment(payload.start).format("yyyy-MM-DD"),
      toDate: moment(payload.end).format("yyyy-MM-DD")
    };
    if (new Date() < new Date(dateRange.toDate)) {
      dateRange.toDate = moment(new Date()).format("yyyy-MM-DD");
    }

    dispatch(
      userActions.getUserCalendarData(user_id, dateRange, loginType)
    );
  };

  // show user left detail
  const showUserLeftDetail = () => {
    if (!isEmpty(userDetailData)) {
      return (
        <UserLeftDetail
          userDetailData={userDetailData}
          loginType={loginType}
        />
      );
    } else {
      return (
        <>
          <Card>
            <Skeleton height={100} />
          </Card>
          <Card>
            <Skeleton height={200} />
          </Card>
          <Card>
            <Skeleton height={50} />
          </Card>
        </>
      );
    }
  };

  // on edit user submit
  const onEditUser = (e) => {
    e.preventDefault();
    const reportIds = [];
    reportingIds.map((reportData) => {
      reportIds.push(reportData.value);
    });
    const userEditedData = {
      workerType: editUserDetail.workerType,
      workerEmail: editUserDetail.workerEmail,
      departmentId: editUserDetail.departmentId,
      workerSurname: editUserDetail.workerSurname,
      designationId: editUserDetail.designationId,
      workerFirstName: editUserDetail.workerFirstName,
      workerPhoneNumber: editUserDetail.workerPhoneNumber,
      lastLocationId: lastLocationId,
      reportingIds: reportIds
    };
    dispatch(userActions.setUserLoading(true));
    dispatch(userActions.clearUserErrors());
    dispatch(userActions.clearUserResult());
    dispatch(
      userActions.onEditUserDetail(
        userEditedData,
        userDetailData._id,
        loginType
      )
    );
  };

  // handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditUserDetail({
      ...editUserDetail,
      [name]: value
    });
  };

  // change dynamic inputs
  const handleSelectManagers = (input) => {
    setReportingIds(input);
  };

  return (
    <Starter
      topBarTitle={loginType + " Detail"}
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Register Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Users</a>
          </li>
          <li className="breadcrumb-item active">User Detail</li>
        </Fragment>
      }
    >
      <div className="row mb-3">
        <div className="col-xl-5 col-lg-5 col-md-5 col-sm-5">
          {showUserLeftDetail()}
        </div>
        <div className="col-xl-7 col-lg-7 col-md-7 col-sm-7">
          <UserCalendar
            calendarEvents={calendarEvents}
            handleMonthChange={handleMonthChange}
          />
        </div>
      </div>
      <UserLocationList
        currentUser={currentUser}
        onDeleteFace={deleteFace}
        allLocations={allLocations}
        userAddLoading={userAddLoading}
        newLocationToUser={newLocationToUser}
        addNewLocationToUser={addNewLocationToUser}
        setNewLocationToUser={setNewLocationToUser}
        usersLocationAndFace={userDetailData?.usersLocationAndFace}
      />
      <UserEdit
        onEditUser={onEditUser}
        department={department}
        currentUser={currentUser}
        editLoading={userLoading}
        showOptions={showOptions}
        designation={designation}
        allLocations={allLocations}
        reportingIds={reportingIds}
        editUserDetail={editUserDetail}
        lastLocationId={lastLocationId}
        reportingManagers={reportingManagers}
        setLastLocationId={setLastLocationId}
        handleInputChange={handleInputChange}
        handleSelectManagers={handleSelectManagers}
      />
    </Starter>
  );
};

export default UserDetail;
